// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_promise from "../../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.mjs";
import * as AuthRepoConfig$PorterinFeature from "./AuthRepoConfig.mjs";
import * as SignupDummyResponse$PorterinFeature from "./dummy-responses/SignupDummyResponse.mjs";
import * as ResendOtpDummyResponse$PorterinFeature from "./dummy-responses/ResendOtpDummyResponse.mjs";
import * as OtpValidationDummyResponse$PorterinFeature from "./dummy-responses/OtpValidationDummyResponse.mjs";
import * as CustomerExistsDummyResponse$PorterinFeature from "./dummy-responses/CustomerExistsDummyResponse.mjs";
import * as CustomerLogoutDummyResponse$PorterinFeature from "./dummy-responses/CustomerLogoutDummyResponse.mjs";
import * as CustomerProfileDummyResponse$PorterinFeature from "./dummy-responses/CustomerProfileDummyResponse.mjs";

function checkCustomerExists(_web_tracking_id, _mobile, _query_params) {
  return Js_promise.then_((function (result) {
                return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                            return Curry._1(AuthRepoConfig$PorterinFeature.CustomerExistsResponseConverter.execute, result);
                          });
              }), new Promise((function (resolve, param) {
                    resolve({
                          TAG: /* Success */0,
                          _0: CustomerExistsDummyResponse$PorterinFeature.dummyResponse
                        });
                  })));
}

function customerLogout(_web_tracking_id, _mobile, _auth_token) {
  return Js_promise.then_((function (result) {
                return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                            return Curry._1(AuthRepoConfig$PorterinFeature.CustomerLogoutResponseConverter.execute, result);
                          });
              }), new Promise((function (resolve, param) {
                    resolve({
                          TAG: /* Success */0,
                          _0: CustomerLogoutDummyResponse$PorterinFeature.dummyResponse
                        });
                  })));
}

function validateOtp(_web_tracking_id, _mobile, _email, _otp, _name, _whatsapp_consent, _customer_frequency, _agreed_docs, _referral_code, _geo_region_id) {
  return Js_promise.then_((function (result) {
                return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                            return Curry._1(AuthRepoConfig$PorterinFeature.OtpValidationResponseConverter.execute, result);
                          });
              }), new Promise((function (resolve, param) {
                    resolve({
                          TAG: /* Success */0,
                          _0: OtpValidationDummyResponse$PorterinFeature.dummyResponse
                        });
                  })));
}

function resendOtp(_web_tracking_id, _mobile, _option) {
  return Js_promise.then_((function (result) {
                return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                            return Curry._1(AuthRepoConfig$PorterinFeature.ResendOtpResponseConverter.execute, result);
                          });
              }), new Promise((function (resolve, param) {
                    resolve({
                          TAG: /* Success */0,
                          _0: ResendOtpDummyResponse$PorterinFeature.dummyResponse
                        });
                  })));
}

function customerSignUp(_web_tracking_id, _mobile, _email) {
  return Js_promise.then_((function (result) {
                return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                            return Curry._1(AuthRepoConfig$PorterinFeature.SignupResponseConverter.execute, result);
                          });
              }), new Promise((function (resolve, param) {
                    resolve({
                          TAG: /* Success */0,
                          _0: SignupDummyResponse$PorterinFeature.dummyResponse
                        });
                  })));
}

function customerProfile(_web_tracking_id, _mobile, _auth_token) {
  return Js_promise.then_((function (result) {
                return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                            return Curry._1(AuthRepoConfig$PorterinFeature.CustomerProfileResponseConverter.execute, result);
                          });
              }), new Promise((function (resolve, param) {
                    resolve({
                          TAG: /* Success */0,
                          _0: CustomerProfileDummyResponse$PorterinFeature.dummyResponse
                        });
                  })));
}

export {
  checkCustomerExists ,
  customerLogout ,
  validateOtp ,
  resendOtp ,
  customerSignUp ,
  customerProfile ,
}
/* AuthRepoConfig-PorterinFeature Not a pure module */
